import React from "react";
import NasRouter from "./NasRouter";

const App = <NasRouter />;
//Dummy commit

export default App;
